import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, scale, gradient, verticalOffset }) {
  const randomGradientId1 = `_${useRandomId()}`

  const transformOrigin = '3.7803 13.5699'
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g transform={`scale(${scale},${scale})`} transform-origin={transformOrigin}>
        <path
          d="M6.75031 0.129883H0.810311C3.26031 17.9299 -0.419694 24.2199 0.0403063 25.4499C0.430306 26.4999 2.65031 27.0099 3.78031 27.0099C4.91031 27.0099 7.1203 26.4999 7.5203 25.4499C7.9803 24.2199 4.30031 17.9299 6.75031 0.129883Z"
          fill={`url(#${randomGradientId1})`}
        />
        <defs>
          <linearGradient
            id={randomGradientId1}
            x1="3.7786"
            y1="2.02218"
            x2="3.7786"
            y2="26.9854"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8488" stopColor={gradient[0]} />
          </linearGradient>
        </defs>
      </g>
    </g>
  )
}
